import React, { FC, useEffect, useState } from 'react';

import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { Botao } from '../Botao/Botao';
import { TextoPequeno } from '../Tipografia/Texto';
import { MensagensErroServidorProps } from './MensagensErroServidor';
import { MensagensErroServidorView } from './MensagensErroServidorView';


export const MensagemErroServidorRede: FC<MensagensErroServidorProps> = ({erro, retry, className}) => {
  const [clicado, setClicado] = useState(false);
  const clicar = () => {
    retry && retry();
    setClicado(true);
  }
  const resetar = () => setClicado(false);

  useEffect(() => {
    let timeoutId = 0;
    if (clicado) {
      timeoutId = window.setTimeout(resetar, 5000);
    }

    return () => clearTimeout(timeoutId);
  }, [clicado]);

  return <>
    <MensagensErroServidorView
      className={className}
      aparencia="warning"
      titulo="Não foi possível carregar as informações"
    >
      <TextoPequeno><strong>Dica:</strong> Verifique sua conexão com a internet</TextoPequeno>

      {retry &&
      <Centralizado>
        <Botao onClick={clicar} isLoading={clicado}>Tentar novamente</Botao>
      </Centralizado>
      }
    </MensagensErroServidorView>
  </>
}


const Centralizado = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${Spacing.unit}px;
`;
